import { Button } from "antd";
import Style from "../output.module.css";
import { submitScenarioType } from "../../../@types/user";
import React, { Fragment, useEffect, useState } from "react";
import NumberFormat from "../../../utils/NumberFormat";
import GraphScreen from "./GraphScreen";
import WrapperOutput from "./WrapperOutput";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";
import ScrollerWrapper from "../../scrollerWrapper";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import BarChartIcon from '@mui/icons-material/BarChart';
import PrintBtn from "../../PrintBtn";
import CurrencyIconRenderer from "../../CurrencyIconRendered";
import DeltaTableScreen from "./DeltaTableScreen";
import { filteredResulttype } from "../types";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";


type comparedScreenPropType={
    result:filteredResulttype[],
    myCurrency:string,
    setCompareEnabled:(res:boolean)=> void,
    mapper:{name:string,data:string[]}[],
    submitableScenario:submitScenarioType[]
}


const ComparedScreen = ({result,myCurrency,setCompareEnabled,mapper,submitableScenario}:comparedScreenPropType)=>{

    const [myresult,setMyresult] = useState<filteredResulttype[]>([]);
    const [forwardResult,setForwardResult] = useState<filteredResulttype[]>([]);

    const [prep,setPrep] = useState<{
        name:string,
        data:{
            name:string,
            value:string[]
        }[],
        servicableYear:number,
        yearsRemaining:number
    }[][]>([]);

    const [showGraph,setShowGraph] = useState(false);
    const [showTable,setShowTable] = useState(false);
    const [deltaTable,setDeltaTable] = useState(false);


    useEffect(()=>{

        window.scrollTo(0,0);
        if(myresult.length < 1)
        setMyresult([...result]);

    },[])

    useEffect(()=>{
        if(myresult.length < 1) return;


        let x:filteredResulttype[]= [[]];
        myresult.forEach(element => {
            x[0].push(element[element.length -1]);
        });

        setForwardResult(x);
        // console.log("x",x);

    },[myresult])

    useEffect(()=>{

        if(forwardResult.length < 1) return;


        let localPrep : {
            name:string,
            data:{
                name:string,
                value:string[]
            }[],
            servicableYear:number,
            yearsRemaining:number
        }[][] = [];

        forwardResult.forEach((elem,index) => {

            let x:{
                name:string,
                data:{name:string,value:string[]}[],
                servicableYear:number,
                yearsRemaining:number
            }[] = [];

            elem.forEach((element,ind) => {
    
                let inflation = (element.cashFlow.map(elem=> elem.inflation).reduce((a,b)=> a+b) || 0) / element.cashFlow.length;
                let tax_rate = (element.cashFlow.map(elem=> elem.tax).reduce((a,b)=> a+b) || 0) / element.cashFlow.length;
                let wacc = (element.cashFlow.map(elem=> elem.wacc).reduce((a,b)=> a+b) || 0) / element.cashFlow.length;
                let volume = (element.cashFlow.map(elem=> elem.volume).reduce((a,b)=> a+b) || 0) / element.cashFlow.length;
                let month = (element.cashFlow.map(elem=> elem.tables.ds.length).reduce((a,b)=> a>b ? a : b));
    
                let Volume:string[] = Array.from({length:month}).map((elem,ind)=> ind === 0 || ind > element.cashFlow.map(elem=> elem.greatestTimeFrame).reduce((a,b)=> a>b ? a : b) ? "0" : (volume ? volume.toString() : "0") );
                let Inflation:string[] = Array.from({length:month}).map((elem,ind)=> ind === 0 || ind > element.cashFlow.map(elem=> elem.greatestTimeFrame).reduce((a,b)=> a>b ? a : b) ? "0" : (inflation ? inflation.toString() : "0") );
                let Lta:string[] = Array.from({length:month}).map((elem,ind)=> ("0") );
                let Tax:string[] = Array.from({length:month}).map((elem,ind)=> (ind > element.cashFlow.map(elem=> elem.greatestTimeFrame).reduce((a,b)=> a>b ? a : b) ? "0" : (tax_rate ? tax_rate.toString() : "0") ) );
                let Wacc:string[] = Array.from({length:month}).map((elem,ind)=> (ind > element.cashFlow.map(elem=> elem.greatestTimeFrame).reduce((a,b)=> a>b ? a : b) ? "0" : (wacc ? wacc.toString() : "0" ) ) );
    
                x = [
                    ...x,
                    {
                        name:element.name,
                        data:[
                            {
                                name:'Volume',
                                value:Volume
                            },
                            {
                                name:'Inflation',
                                value:Inflation
                            },
                            {
                                name:'Long term agreement',
                                value:Lta
                            },
                            {
                                name:'Tax Rate',
                                value:Tax
                            },
                            {
                                name:'WACC',
                                value:Wacc
                            }
                        ],
                        servicableYear: element.cashFlow.map(elem=> elem.greatestTimeFrame).reduce((a,b)=> a>b ? a : b),
                        yearsRemaining: element.cashFlow.map(elem=> elem.years_remaining).reduce((a,b)=> a>b ? a : b)
                    }
                ]
                
            });
        
            localPrep.push(x);
        });

        setPrep(localPrep);


    },[forwardResult])


    useEffect(()=>{

        console.log("Compared prep",prep);

    },[prep])

    return(
        <div className="outputScreen">
        {
            (!showGraph && !showTable) &&
            <WrapperOutput
            name={["Home","Output","Delta"]}
            onBackPress={()=> setCompareEnabled(false)}
            leftButtons={[
                <PrintBtn />,
                <Button
                type="text" 
                className={`${Style.rtBtn}`}
                onClick={()=> setShowTable(true) }
                >
                    <MonetizationOnIcon />
                    Delta Cash Flows
                </Button>,                
                <Button 
                type="text" 
                className={`${Style.rtBtn}`}
                onClick={()=> setShowGraph(true) }
                >
                    <BarChartIcon />
                    Delta Graph
                </Button>
            ]}
            >
                <div className={`${Style.resHolder} printable`}>
                {
                    myresult.map((aelem,aindex)=>(
                        <ScrollerWrapper
                        contentCntStyle={{
                            gap:"15px"
                        }}
                        >
                    <>

                    {
                        mapper.map((outerElem,outerInd)=>(
                            <Table key={outerInd} sx={{
                                borderCollapse: 'separate',
                                borderSpacing: '5px', // horizontal and vertical gap
                                background:"white"
                                }}>
                                <TableHead> 
                                    <TableRow>
                                        <TableCell 
                                        className="outputTableHeaderCell"
                                        align="center" 
                                        colSpan={aelem.map((el)=> el.output.jobNames?.length || 0).reduce((a,b)=> a+b) + 1}>
                                            <div
                                            style={{
                                                minHeight:"35px",
                                                display:"flex",
                                                alignItems:"center",
                                                justifyContent:"center"
                                            }}
                                            >
                                                {outerElem.name}
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="outputTableNameCell">

                                        </TableCell>
                                        {
                                            aelem?.map((el,ind)=>(
                                                <TableCell 
                                                className="outputTableSceCell"
                                                align="center" 
                                                key={`scename${ind}`} 
                                                colSpan={(el.output.jobNames?.length || 1)}>
                                                    {el.name}
                                                </TableCell>
                                            ))
                                        }
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="outputTableNameCell">

                                        </TableCell>
                                        {
                                            aelem?.map((el,ind)=>(
                                                <Fragment key={`scename${ind}`}>
                                                {
                                                    el.output.jobNames.map((elj,inj)=>(
                                                        <TableCell 
                                                        className="outputTableJobCell"
                                                        align="center" 
                                                        key={`scename${ind}${inj}`} 
                                                        colSpan={1}>
                                                        {elj.name}
                                                        </TableCell>
                                                    ))
                                                }
                                            </Fragment>
                                            
                                            ))
                                        }
                                    </TableRow>

                                </TableHead>
                                <TableBody>
                                    {
                                        outerElem.data.map((field,fieldInd)=>(
                                            ((outerInd === 0 && fieldInd === 1) || (outerInd === 0 && fieldInd === 2)) ?
                                            <></>
                                            :
                                            <React.Fragment key={`field${fieldInd}`}>
                                                <TableRow>
                                                    <TableCell 
                                                    align="left" 
                                                    className="outputTableNameCell"
                                                    >
                                                        <div style={{width:outerInd === 0 ? "210px" : outerInd === 1 ? "225px" : "210px"}}>
                                                        {field}
                                                        </div>
                                                    </TableCell>
                                                    {
                                                        aelem.map((sce,sceind)=>(
                                                            sce.output.data[outerInd].data[fieldInd].value.map((cell,cellInd)=>(
                                                                <TableCell 
                                                                align="center" 
                                                                key={`cellValue${cellInd}`}
                                                                className={
                                                                    `
                                                                    outputTableDataCell
                                                                    ${
                                                                        (outerInd === 0 && fieldInd ===0) &&
                                                                        ((
                                                                            (sce.output.data[outerInd].data[2].value[cellInd] != 0 && sce.output.data[outerInd].data[fieldInd].value[cellInd] < sce.output.data[outerInd].data[2].value[cellInd]) || 
                                                                            (sce.output.data[outerInd].data[1].value[cellInd] != 0 && sce.output.data[outerInd].data[fieldInd].value[cellInd] > sce.output.data[outerInd].data[1].value[cellInd] )
                                                                        )
                                                                            ?
                                                                            "danger"
                                                                            :
                                                                            "green"
                                                                        )
                                                                    }
                                                                    ${
                                                                        (
                                                                        (outerInd === 0 && fieldInd ===8) ||
                                                                        (outerInd === 0 && fieldInd ===9) ||
                                                                        (outerInd === 0 && fieldInd ===10) ||
                                                                        (outerInd === 0 && fieldInd ===11) ||
                                                                        (outerInd === 0 && fieldInd ===20) ||
                                                                        (outerInd === 0 && fieldInd ===21) ||
                                                                        // (outerInd === 0 && innerInd ===16) ||
                                                                        // (outerInd === 0 && innerInd ===17) ||
                                                                        // (outerInd === 0 && innerInd ===21) ||
                                                                        (outerInd === 1 && fieldInd ===6) ||
                                                                        (outerInd === 1 && fieldInd ===7) ||
                                                                        (outerInd === 1 && fieldInd ===8) ||
                                                                        (outerInd === 1 && fieldInd ===9) ||
                                                                        (outerInd === 1 && fieldInd ===10) ||
                                                                        (outerInd === 1 && fieldInd ===11) ||
                                                      
                                                                        (outerInd === 2 && fieldInd ===6) ||
                                                                        (outerInd === 2 && fieldInd ===7) ||
                                                                        (outerInd === 2 && fieldInd ===8) ||
                                                                        (outerInd === 2 && fieldInd ===9) ||
                                                                        (outerInd === 2 && fieldInd ===10) ||
                                                                        (outerInd === 2 && fieldInd ===11) 
                                                                    ) &&
                                                                    (
                                                                        sce.output.data[outerInd].data[fieldInd].value[cellInd] < 0 ? "danger" : "green"
                                                                    )
                                                                    }
                                                                    ${
                                                                        (outerInd === 0 && (fieldInd === 24 || fieldInd === 25 || fieldInd === 26 || fieldInd === 27 )) && 
                                                                        ((((sce.output.data[0].data[fieldInd].value[cellInd]/sce.output.data[0].data[0].value[cellInd]) * 100 > ( (sce.cashFlow.map(elem=> elem.atrosRate)[cellInd] || 0) ) ) ) ?
                                                                        "green"
                                                                        :
                                                                        "danger")
                                                                    }
                                                                    ${
                                                                        ((outerInd === 1 || outerInd === 2) && (fieldInd === 12 || fieldInd === 13 || fieldInd === 14 || fieldInd === 15)) && 
                                                                        ((((sce.output.data[0].data[fieldInd+11].value[cellInd]/sce.output.data[0].data[0].value[cellInd]) * 100 > ( (sce.cashFlow.map(elem=> elem.atrosRate)[cellInd] || 0) ) ) ) ?
                                                                        "green"
                                                                        :
                                                                        "danger")
                                                                    }
                                                                    ${
                                                                        (outerInd === 2 && fieldInd ===16) &&
                                                                        (sce.output.data[outerInd].data[fieldInd].value[cellInd] < ( (sce.cashFlow.map(elem=> elem.irrRate)[cellInd] || 0) )  ? "danger" : sce.output.data[outerInd].data[fieldInd].value[cellInd] != 11011 && "green")
                                                                    
                                                                    }
                                                                    ${
                                                                        ((outerInd === 3 && (fieldInd ===0 || fieldInd ===1 || fieldInd ===2 || fieldInd ===3))) &&
                                                                        (
                                                                            (
                                                                                sce.output.data[outerInd].data[fieldInd].value[cellInd] > ( (sce.cashFlow.map(elem=> elem.ot_above_x)[cellInd] || 0) )  && 
                                                                                sce.output.data[outerInd].data[fieldInd].value[cellInd] <= ( (sce.cashFlow.map(elem=> elem.ot_above_y)[cellInd] || 0) ) 
                                                                            )? "danger" :
                                                                            (
                                                                                sce.output.data[outerInd].data[fieldInd].value[cellInd] > ( (sce.cashFlow.map(elem=> elem.ot_above_y)[cellInd] || 0))  && 
                                                                                sce.output.data[outerInd].data[fieldInd].value[cellInd] <= 8500
                                                                            ) ? "superdanger" : 
                                                                            (
                                                                                sce.output.data[outerInd].data[fieldInd].value[cellInd] > 8500 && "notpossiblevalue"
                                                                            )
                                                                        )
                                                                    }
                                                                    `
                                                                }
                                                                >
                                                                    
                                                                    <div style={{
                                                                        display:"flex",
                                                                        alignItems:"center",
                                                                        justifyContent:"center",
                                                                        gap:"2px",
                                                                        // minHeight:"55px"
                                                                    }}>
                                                                        {
                                                                        
                                                                            sce.output.data[outerInd].data[fieldInd].type === "currency" &&
                                                                            <CurrencyIconRenderer type={myCurrency} className="currencyIcon" />
                                                      
                                                                        }
                                                                        {
                                                                            (outerInd === 2 && fieldInd === 16) ?
                                                                            (sce.output.data[outerInd].data[fieldInd].value[cellInd] === 11011) &&
                                                                            "NA"
                                                                            :
                                                                            myCurrency === "INR" ?
                                                                                NumberFormat.toINDstandard((cell).toFixed(2))
                                                                                :
                                                                                NumberFormat.toUSstandard((cell).toFixed(2))
                                                                            
                                                                        }
                                                                        {
                                                                             (
                                                                                sce.output.data[outerInd].data[fieldInd].type === "perc" && 
                                                                                sce.output.data[outerInd].data[fieldInd].value[cellInd] != 11011 
                                                                            ) &&
                                                                            <span>
                                                                                %
                                                                            </span>
                                                                          
                                                                        }
                                                                    </div>
                                                                </TableCell>
                                                            ))
                                                        ))
                                                    }   
                                                </TableRow>
                                            {
                                                (
                                                    (outerInd === 0 && fieldInd === 0) ||
                                                    (outerInd === 0 && fieldInd === 7) ||
                                                    (outerInd === 0 && fieldInd === 9) ||
                                                    (outerInd === 0 && fieldInd === 11) ||
                                                    (outerInd === 0 && fieldInd === 15) ||
                                                    (outerInd === 0 && fieldInd === 17) ||
                                                    (outerInd === 0 && fieldInd === 19) ||
                                                    (outerInd === 0 && fieldInd === 21) ||
                                                    (outerInd === 0 && fieldInd === 23) ||
                                                    (outerInd === 0 && fieldInd === 25) ||
    
                                                    ((outerInd === 1 || outerInd === 2) && fieldInd === 0) ||
                                                    ((outerInd === 1 || outerInd === 2) && fieldInd === 5) ||
                                                    ((outerInd === 1 || outerInd === 2) && fieldInd === 7) ||
                                                    ((outerInd === 1 || outerInd === 2) && fieldInd === 9) ||
                                                    ((outerInd === 1 || outerInd === 2) && fieldInd === 11) ||
                                                    ((outerInd === 1 || outerInd === 2) && fieldInd === 13) ||
    
                                                    (outerInd === 3 && fieldInd === 1) ||
                                                    (outerInd === 3 && fieldInd === 3) ||
                                                    (outerInd === 3 && fieldInd === 4) ||
                                                    (outerInd === 3 && fieldInd === 6) ||
                                                    (outerInd === 3 && fieldInd === 10) ||
                                                    (outerInd === 3 && fieldInd === 11)
                                                ) &&
                                                <TableRow 
                                                sx={{
                                                    height:"25px"
                                                    }}>
                                                        <TableCell 
                                                        sx={{
                                                          
                                                        }}
                                                        colSpan={aelem.map((el)=> el.output.jobNames?.length || 0).reduce((a,b)=> a+b) + 1}
                                                        >
                                                            <hr style={{
                                                                border: "none",
                                                                borderTop: "2px dashed gainsboro"
                                                            }} />
                                                        </TableCell>
                                                    
                                                </TableRow>
                                            }
                                            </React.Fragment>
                                            
                                        ))
                                    }

                                </TableBody>

                            </Table>
                        ))
                    }

                    </>
                </ScrollerWrapper>
                    ))
                }

                
                </div>
            </WrapperOutput>
        }
        {
            
            (showGraph) &&
            <WrapperOutput
            onBackPress={()=> setShowGraph(false) }
            name={["Home","Output","Delta","Graphs"]}
            leftButtons={[
                <PrintBtn />
            ]}
            >
                <GraphScreen 
                mapper={mapper}
                myresult={myresult.map(el=> [el[el.length -1]] )}
                />
            </WrapperOutput>
            
            
        }
        {
            showTable &&
            <WrapperOutput
            onBackPress={()=> setShowTable(false) }
            name={["Home","Output","Delta","Cash Flows"]}
            leftButtons={[
                <PrintBtn />
            ]}
            >
                <DeltaTableScreen
                    myresult={forwardResult}
                    prep={prep}
                    setPrep={setPrep}
                    submitableScenario={submitableScenario}
                />
            </WrapperOutput>
        }
        </div>
    )

    return <></>
}

export default ComparedScreen;